import Vue from 'vue'
import App from './App.vue'
import router from './router'

import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

import './util/rem'
import './assets/normalize.css'

import dayjs from 'dayjs'
Vue.prototype.dayjs = dayjs;

import Api from './util/http.js';

Vue.prototype.$api = Api

import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

import {toast} from './util/toast.js';
Vue.prototype.$toast = toast

import {toasts} from './util/toast.js';
Vue.prototype.$toasts = toasts

import {toastf} from './util/toast.js';
Vue.prototype.$toastf = toastf

import {toaste} from './util/toast.js';
Vue.prototype.$toaste = toaste

import store from './store'


import vueEsign from 'vue-esign'
Vue.use(vueEsign)

Vue.config.productionTip = false

import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload)
import 'babel-polyfill'
require('es6-promise').polyfill()

import imgCompress from './util/imgCompress.js' //这里注意自己的路径
Vue.prototype.$imgcompress = imgCompress  //注册为全局变量

import qs from 'qs'

Vue.config.silent = true

router.beforeEach(async(to, from, next) => {
    if (to.name == "login"||to.name == 'report'||to.name == 'engineering_institute'||to.name == 'sdeclare') { //防止页面死循环
        next()
    } else {
        if (!store.getters.token) {
            next({ path: "/login" })
        } else {
            next()
        }
    }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')


